import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HospitalStateService } from './services/hospitalstate.service';
import { LoginService } from './login.service';
import { UserAuthService } from './auth/userAuth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent {
  constructor(
    private translate: TranslateService,
    private _hospital: UserAuthService,
    private _loginService: LoginService,
    private _hospitalState: HospitalStateService
  ) {
    translate.addLangs(['en', 'fr', 'es', 'de', 'hi', 'gu']);
    translate.setDefaultLang('en');

    const savedLang = localStorage.getItem('app-language');
    const browserLang = translate.getBrowserLang() || 'en';
    const langToUse = savedLang && savedLang.match(/en|fr|es|de|hi|gu/)
      ? savedLang
      : (browserLang.match(/en|fr|es|de|hi|gu/) ? browserLang : 'en');
    translate.use(langToUse);
    this.loadHospitalData();
  }

  loadHospitalData() {
    const hospitalId = this._loginService.getHospitalId();
    if (!hospitalId) return;
    this._hospital.getHospital(hospitalId).subscribe(res => {
      this._hospitalState.setHospital(res.result);
    });
  }
}
